import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ChatBot = () => {
  const { t } = useTranslation();
  const [messages, setMessages] = useState([
    { id: 1, text: t('design.support.chatWelcome'), isBot: true }
  ]);
  const [newMessage, setNewMessage] = useState('');

  useEffect(() => {
    setMessages((current) => {
      if (current.length === 1 && current[0].isBot) {
        return [{ id: 1, text: t('design.support.chatWelcome'), isBot: true }];
      }
      return current;
    });
  }, [t]);

  const handleSend = (event) => {
    event.preventDefault();
    if (!newMessage.trim()) return;

    const userMessage = { id: Date.now(), text: newMessage, isBot: false };
    setMessages((current) => [...current, userMessage]);
    setNewMessage('');

    setTimeout(() => {
      setMessages((current) => [
        ...current,
        {
          id: Date.now() + 1,
          text: t('design.support.chatReply'),
          isBot: true
        }
      ]);
    }, 700);
  };

  return (
    <div className="flex h-[520px] flex-col">
      <div className="flex-1 space-y-4 overflow-y-auto rounded-[28px] border border-stone-200 bg-stone-50/80 p-4">
        {messages.map((message) => (
          <div key={message.id} className={`flex ${message.isBot ? 'justify-start' : 'justify-end'}`}>
            <div className={message.isBot ? 'max-w-[80%] rounded-[22px] bg-white px-4 py-3 text-sm leading-7 text-slate-700 shadow-sm' : 'max-w-[80%] rounded-[22px] bg-teal-700 px-4 py-3 text-sm leading-7 text-white'}>
              {message.text}
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={handleSend} className="mt-4 flex gap-3">
        <input
          type="text"
          value={newMessage}
          onChange={(event) => setNewMessage(event.target.value)}
          placeholder={t('design.support.chatPlaceholder')}
          className="input-shell flex-1"
        />
        <button type="submit" className="btn-primary">{t('design.support.send')}</button>
      </form>
    </div>
  );
};

export default ChatBot;
